export default "__VITE_ASSET__DJTJbyjk__"